module.exports = __webpack_public_path__ + "img/16_85.1654178b.png";